import { CSSProperties } from "react"

export type NotificationType = "success" | "warning" | "error"

export interface NotificationConfig {
	title: string
	message?: string
	autoClose?: number | false
	position?:
		| "top-left"
		| "top-right"
		| "top-center"
		| "bottom-left"
		| "bottom-right"
		| "bottom-center"
	withCloseButton?: boolean
	id?: string
	style?: CSSProperties
}

export interface NotificationColors {
	background: string
	color: string
	border?: string
}

export const NOTIFICATION_COLORS: Record<NotificationType, NotificationColors> =
	{
		success: {
			background: "var(--mantine-color-royal-48)", // #EBFFEE
			color: "var(--mantine-color-royal-49)", // #02542D
			border: "var(--mantine-color-royal-49)"
		},
		warning: {
			background: "var(--mantine-color-royal-50)", // #FFF1C2
			color: "var(--mantine-color-royal-55)", // #FF8F00
			border: "var(--mantine-color-royal-55)"
		},
		error: {
			background: "var(--mantine-color-royal-46)", // #FFD7D7
			color: "var(--mantine-color-royal-52)", // #C92A2A
			border: "var(--mantine-color-royal-52)"
		}
	}

export const NOTIFICATION_DEFAULTS = {
	autoClose: 5000,
	position: "top-center" as const,
	withCloseButton: true
}
